/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Component } from 'react';
import AsyncFn, { AsyncChildren, AsyncProps } from 'react-async';

export type AsyncComponent<T> = Component<AsyncProps<T>>;

export interface AsyncResolvedProps<T> {
    children: AsyncChildren<T>;
}

export type AsyncResolvedComponent<T> = Component<AsyncResolvedProps<T>>;

export interface AsyncRejectedProps<T> {
    children: AsyncChildren<T>;
}

export type AsyncRejectedComponent<T> = Component<AsyncRejectedProps<T>>;

// @ts-expect-error
export const Async = AsyncFn as AsyncComponent;

// @ts-expect-error
export const Resolved = Async.Resolved as AsyncResolvedComponent;
// @ts-expect-error
export const Rejected = Async.Rejected as AsyncRejectedComponent;

export { default as AsyncErrorHandling } from './error-handling';
